export default function setRootFontSize (doc, win) {
  var docEl = doc.documentElement,
    resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
    recalc = () => {
      var clientWidth = docEl.clientWidth
      if (!clientWidth) return
      if (clientWidth >= 2560) {
        docEl.style.fontSize = '100px'
      } else if (clientWidth <= 600) {
        docEl.style.fontSize = '32px'
      } else {
        docEl.style.fontSize = 100 * (clientWidth / 1920) + 'px'
      }
      console.log('rd: recalc -> docEl.style.fontSize', docEl.style.fontSize)
    }
  if (!doc.addEventListener) return
  win.addEventListener(resizeEvt, recalc, false)
  doc.addEventListener('DOMContentLoaded', recalc, false)
}
